export default __webpack_public_path__ + "static/media/androidstudio.d26fafaf.svg";